<template>
  <div class="login">
    <b-container>
      <b-row>
        <b-col md="7" lg="5">
          <div class="form-decorated">
            <loader v-if="isLoading" />

            <b-form @submit.prevent="onSubmit" novalidate>
              <b-form-group id="email" label="E-mail address" label-for="email">
                <b-form-input id="email" type="text" v-model="email" />
              </b-form-group>

              <b-button type="submit" class="btn-decorated">Reset Password</b-button>
            </b-form>
          </div>

        </b-col>
        <!--
        <b-col align-self="end" class="title">
          <h1>
            Full <br>
            music <br>
            experience
          </h1>
        </b-col>
        -->
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Loader from '@/components/widgets/Loader'

export default {
  name: 'ForgotPassword',
  components: {
    Loader
  },
  data () {
    return {
      email: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoading', 'error'])
  },
  methods: {
    async onSubmit (evt) {
      if (!this.email) return
      try {
        await this.$store.dispatch('auth/resetPassword', this.email)
      } catch (e) {
        this.$store.dispatch('flash/showMessage', { message: 'Please enter a valid e-mail address', type: 'error' })
        return
      }

      this.$store.dispatch('flash/showMessage', { message: 'We\'ve sent an email with password reset instructions to your email address' })
      this.$router.push({name: 'account-login'})
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

.login {
  margin: -48px -15px 0 -15px;
  padding-top: 48px;
  background-image: linear-gradient(to bottom, rgba(0,0,0,0) 57%, $body-bg),
                    url(/static/img/login-signup-bg.jpg);

  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 90vh;

  .row {
    margin-top: 5em;
    margin-bottom: 5em;
  }

  .title {
    display: none;
    flex-direction: row-reverse;

    h1 {
      font-size: 4rem;
    }
  }

  @include media-breakpoint-up(lg) {
    .title {
      display: flex;
    }
  }
}

.form-decorated {
  margin: 3em;

  form {
    position: relative;
    z-index: 1;
  }

  .btn-decorated {
    position: absolute;
    left: calc(50% - 85px);
  }

  .errors {
    font-size: 0.8em;
  }
}

.social-login {
  margin: 0 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/account/ForgotPassword.vue